module.exports = __webpack_public_path__ + "img/14.2333a303.png";